import React, { useEffect, useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import "ag-grid-enterprise";
import "styles/ag-grid-header-style.css";

// ✅ Updated CSS imports for AG Grid v29+
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-community/styles/ag-theme-material.css";

import { AgGridReact } from "ag-grid-react"; // ✅ AgGridColumn removed
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';
import AgGridFilterGroupView from '@fuse/components/AgGridFilterGroupView';
import { setGroupViewTabValue } from "../../../app/main/reports/store/reportViewDialogReducer";
import { useDispatch } from "react-redux";
import _ from '@lodash';
import axios from "@fuse/utils/axios";
import { Controller, useForm } from 'react-hook-form';
import { Autocomplete } from '@material-ui/lab';
import FuseLoading from '@fuse/core/FuseLoading';
import { dateReformatTo_mmm_dd_yyyy } from '@fuse/utils/dateOperations';
import TableHeader from '@fuse/components/AgGridFilterGroupView/components/TableHeader';
import { TextField } from '@material-ui/core';
import { formatString } from "@fuse/utils/stringOperations";
import useToast from "@fuse/hooks/useToast";

const useStyles = makeStyles({
  root: {
    '& .MuiDataGrid-columnsContainer': {
      background: '#8f8f8f26'
    }
  }
});

const action_to_color = {
  "CREATED": "green",
  "UPDATED": "orange",
  "ARCHIVED": "red",
  "RESTORED": "blue",
  "DELETED": "red"
};

function ActivityAgGridListing({ displayTableName = '' }) {
  const classes = useStyles();
  const [activities, setActivities] = useState([]);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight - 330);
  const [rowGroupPanelShow, setRowGroupPanelShow] = useState('never');
  const [groupByArr, setGroupByArr] = useState([]);
  const [companyId, setCompanyId] = useState(null);
  const dispatch = useDispatch();
  const gridRef = useRef();
  const toast = useToast(dispatch);
  const [selectedModuleApi, setSelectedModuleApi] = useState('');
  const [logsLoading, setLogsLoading] = useState(false);
  const [logs, setLogs] = useState([]);
  const [module, setModule] = useState('');
  const [selectedValue, setSelectedValue] = useState({});
  const [displayName, setDisplayName] = useState('');

  const moduleWiseActivityApiMap = [ /* unchanged */];

  const actionConst = { /* unchanged */ };

  // ✅ Column Definitions moved from JSX into state
  const [columnDefs, setColumnDefs] = useState([]);

  // Cell renderer logic moved here
  const cellRenderer = (params) => {
    if (params.colDef.field === "action") {
      return `<span style="color:${action_to_color[params.value]};font-weight:bold;">${params.value}</span>`;
    } if (
      ["description", "previous_value", "current_value"].includes(params.colDef.field)
    ) {
      return `<abbr style="text-decoration:none;" title="${params.value}">${params.value}</abbr>`;
    }
    return params.value;

  };

  const generateHeaderLabel = (header) => {
    return header
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
      .join(" ");
  };

  const frameworkComponents = {
    customFilter: CustomFilter,
  };

  useEffect(() => {
    const headers = [
      'action_id',
      'serial_number',
      'action_date_and_time',
      'action',
      'field_name',
      'previous_value',
      'current_value',
      'name',
      'email',
      'user_role',
      'description',
      'company_name'
    ];

    const updatedDefs = headers.map((header) => ({
      field: header,
      headerName: generateHeaderLabel(header),
      minWidth:
        ['service_provider_name', 'service_level_agreement_name', 'action_date_and_time'].includes(header)
          ? 300
          : 200,
      sortable: true,
      filter: 'agTextColumnFilter',
      resizable: true,
      cellRenderer,
      headerComponent: (props) => CustomFilter(props, header, gridRef)
    }));

    setColumnDefs(updatedDefs);
  }, [module]);

  useEffect(() => {
    setActivities(logs);
    if (logs.length) {
      gridRef?.current?.api?.hideOverlay();
    } else {
      gridRef.current?.api?.showNoRowsOverlay();
    }
  }, [logs]);

  function onColumnRowGroupChanged(event) {
    const api = event?.api;
    if (!api) return;
    const groupedColumns = api.getRowGroupColumns();
    if (groupedColumns.length === 0) setGroupByArr([]);
    else setGroupByArr(groupedColumns);
  }

  useEffect(() => {
    return () => {
      dispatch(setGroupViewTabValue(0));
    };
  }, []);

  const handleModuleChange = (value) => {
    if (!value) setActivities([]);
    setDisplayName(value.name);
    setSelectedModuleApi(value?.api);
    setSelectedValue(value);
    setModule(value?.nameInActivity);
  };

  const handleCompanyId = (companyId) => {
    if (!companyId) setActivities([]);
    setCompanyId(companyId);
  };

  return (
    <>
      <TableHeader
        handleModuleChange={handleModuleChange}
        handleCompanyId={handleCompanyId}
      />

      {!logsLoading && (
        <AgGridFilterGroupView
          tableRef={gridRef}
          setRowGroupPanelShow={setRowGroupPanelShow}
          groupByArrFromList={groupByArr}
          tableName="activity_logs"
          activityModuleName={module}
          logs={logs}
          displayTableName={displayName}
          forActivity
          hideTableName
        />
      )}

      {logsLoading && <FuseLoading />}

      <div
        className="ag-theme-alpine"
        style={{
          width: "100%",
          height: windowHeight + 90,
          fontSize: "12px",
        }}
      >
        <AgGridReact
          ref={gridRef}
          animateRows
          rowData={activities}
          rowHeight={28}
          headerHeight={44}
          overlayLoadingTemplate="<span>Loading...</span>"
          overlayNoRowsTemplate="<span>No Result Found</span>"
          rowGroupPanelShow={rowGroupPanelShow}
          pagination
          defaultColDef={{
            enableRowGroup: true,
            resizable: true,
          }}
          theme="legacy"
          components={frameworkComponents}
          onColumnRowGroupChanged={onColumnRowGroupChanged}
          columnDefs={columnDefs}
        />
      </div>
    </>
  );
}

export default ActivityAgGridListing;
